import React from 'react';
import Button from '../components/controls/button';

const PageNotFound = () => (
  <>
    <br />
    <h2>ЧОЧ. Page Not Found</h2>
    <br />
    <br />
    <Button link='/' variant='contained'>
      Go Home.
    </Button>
  </>
);

export default PageNotFound;
